"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uiIcons = require("@blueprism/ui-icons");

var _InputField = _interopRequireDefault(require("../InputField"));

var _ToolbarButton = _interopRequireDefault(require("../ToolbarButton"));

var _Box = _interopRequireDefault(require("../../layout/Box"));

var _Toolbar = _interopRequireDefault(require("../Toolbar"));

var _Row = _interopRequireDefault(require("../../layout/Row"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CountLabel = _styledComponents["default"].label.withConfig({
  displayName: "PagingToolbar__CountLabel",
  componentId: "bbgw48-0"
})(function (props) {
  return (0, _styledComponents.css)(["font-weight:", ";"], props.theme.font.weight.bold);
});
/**
 *
 * #### Blue Prism styled `PagingToolbar` component

The **PagingToolbar** component is generally a companion for the **Table** component. It provides the general tools and information to help users navigate the **Table** contents.
 */


var _ref2 = /*#__PURE__*/_react["default"].createElement(_uiIcons.ArrowLeft, {
  size: 20
});

var _ref3 = /*#__PURE__*/_react["default"].createElement(_uiIcons.ArrowRight, {
  size: 20
});

var PagingToolbar = function PagingToolbar(_ref) {
  var rowCountLabelId = _ref.rowCountLabelId,
      _ref$rowCountLabel = _ref.rowCountLabel,
      rowCountLabel = _ref$rowCountLabel === void 0 ? '' : _ref$rowCountLabel,
      _ref$pageLabel = _ref.pageLabel,
      pageLabel = _ref$pageLabel === void 0 ? '' : _ref$pageLabel,
      _ref$pageValue = _ref.pageValue,
      pageValue = _ref$pageValue === void 0 ? '1' : _ref$pageValue,
      _ref$prevButtonLabel = _ref.prevButtonLabel,
      prevButtonLabel = _ref$prevButtonLabel === void 0 ? '' : _ref$prevButtonLabel,
      _ref$nextButtonLabel = _ref.nextButtonLabel,
      nextButtonLabel = _ref$nextButtonLabel === void 0 ? '' : _ref$nextButtonLabel,
      _ref$prevButtonDisabl = _ref.prevButtonDisabled,
      prevButtonDisabled = _ref$prevButtonDisabl === void 0 ? false : _ref$prevButtonDisabl,
      _ref$nextButtonDisabl = _ref.nextButtonDisabled,
      nextButtonDisabled = _ref$nextButtonDisabl === void 0 ? false : _ref$nextButtonDisabl,
      _ref$onPageValueChang = _ref.onPageValueChange,
      onPageValueChange = _ref$onPageValueChang === void 0 ? function () {} : _ref$onPageValueChang,
      _ref$onPrevButtonClic = _ref.onPrevButtonClick,
      onPrevButtonClick = _ref$onPrevButtonClic === void 0 ? function () {} : _ref$onPrevButtonClic,
      _ref$onNextButtonClic = _ref.onNextButtonClick,
      onNextButtonClick = _ref$onNextButtonClic === void 0 ? function () {} : _ref$onNextButtonClic;
  return /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    element: "section",
    gap: "small",
    justify: "between",
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    gap: "small",
    justify: "start",
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(CountLabel, {
    htmlFor: rowCountLabelId
  }, rowCountLabel), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    width: "4rem"
  }, /*#__PURE__*/_react["default"].createElement(_InputField["default"], {
    id: rowCountLabelId,
    min: "1",
    type: "number",
    value: pageValue,
    onChange: onPageValueChange
  }))), /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    gap: "small",
    justify: "end",
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], null, pageLabel), /*#__PURE__*/_react["default"].createElement(_ToolbarButton["default"], {
    disabled: prevButtonDisabled,
    onClick: onPrevButtonClick,
    label: prevButtonLabel,
    icon: _ref2
  }), /*#__PURE__*/_react["default"].createElement(_ToolbarButton["default"], {
    disabled: nextButtonDisabled,
    onClick: onNextButtonClick,
    label: nextButtonLabel,
    icon: _ref3
  })));
};

var _default = PagingToolbar;
exports["default"] = _default;